import {FC, useState, createContext, useContext, Dispatch, SetStateAction} from 'react'
import {ToastContainer, toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {WithChildren} from '../../../_mcp/helpers'


export interface ShowToast {
  type: string
  show: boolean
  message: string
}

export interface ToastContextProps {
  notify: (type: string, message: string) => void
}

const initToastContextPropsState = {
  notify: () => {},
}

const ToastContext = createContext<ToastContextProps>(initToastContextPropsState)

const useToast = () => {
  return useContext(ToastContext)
}

const ToastProvider: FC<WithChildren> = ({children}) => {
  const notify = (type: string, message:  string) => {
    type === 'success' &&
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
      })
    type === 'error' &&
      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
      })
  }

  return (
    <ToastContext.Provider value={{notify}}>
      <>
        {children}
        <ToastContainer autoClose={2500} />
      </>
    </ToastContext.Provider>
  )
}

export {ToastProvider, useToast}
